<template>
  <div>
    <button class="mdc-fab mdc-fab--mini mdc-fab--touch" @click="onClick()">
      <div class="mdc-fab__ripple"></div>
      <i class="fa fa-filter" aria-hidden="true"></i>
      <div class="mdc-fab__touch"></div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

button {
  background-color: $light-blue;
  border: 1px solid $blue;
  box-shadow: none !important;
  margin: 0 0.25rem;
  min-width: 4px;
  min-height: 4px;
  max-width: 26px;
  max-height: 26px;
  font-size: 16px;

  i {
    color: $blue;
  }
}
</style>
